
import { uiSetWith } from "./uiSetWith";
import { hideEmptyFields } from "./hideEmptyFields";
import { StaticErrorIfArrayMatches } from "./uiErrorIfNoMatches";

const ExtraActions = {
    uiSetWith,
    hideEmptyFields,
    StaticErrorIfArrayMatches,
};

export default ExtraActions;